import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '@app/core/constants';
@Component({
  selector: 'pms-product-modal',
  templateUrl: './pms-product-modal.component.html',
  styleUrls: ['./pms-product-modal.component.scss']
})
export class PmsProductModalComponent implements OnInit {
  @Input() public title: string;
  @Input() public codeName: string;
  @Input() public mealName: string;
  @Input() public type: string;

  @Input() public showInfo = true;
  @Input() public buttonText: String = 'Ja, löschen';
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  productForm: FormGroup;

  mealOptions = [
    { value: 'FR', label: this.translate.instant('HotelReservations.Breakfast'), color: 'lightsalmon' },
    { value: 'HP', label: this.translate.instant('HotelReservations.HalfBoard'), color: 'lightpink' },
    { value: 'VP', label: this.translate.instant('HotelReservations.FullBoard'), color: 'lightblue' }
  ];

  pmsProductTypes: any = Constants.pmsProductTypes;

  constructor(
    public modal: NgbActiveModal,
    public translate: TranslateService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.buildProductForm();
    this.initialFormValue();
  }

  buildProductForm(): void {
    this.productForm = this.fb.group({
      codeName: ['', Validators.required],
      mealName: ['', Validators.required],
      type: ['', Validators.required]
    });
  }
  initialFormValue(): void {
    this.productForm.patchValue({
      codeName: this.codeName,
      mealName: this.mealName,
      type: this.type ? this.type : 'ratePlanCode'
    });
  }

  onConfirm(): void {
    if (this.productForm.valid) {
      this.modal.close({
        success: true,
        data: this.productForm.value
      });
    } else {
      this.snackBar.open(this.translate.instant('common.isRequired'), 'Close', { duration: 2000 });
    }
  }

  onCancel(): void {
    this.modal.dismiss({
      success: false,
      data: null
    });
  }
}
